import moment from 'moment';

(() => {
  angular
    .module('app')
    .controller('host.views.inpatientClaims.details', InpatientClaimDetailsController);

  InpatientClaimDetailsController.$inject = ['$stateParams', 'abp.services.app.inpatientClaim'];

  function InpatientClaimDetailsController($stateParams, inpatientClaimSvc) {
    const vm = this;
    vm.loading = 0;
    vm.claimNumber = $stateParams.claimNumber;
    vm.timeZoneId = $stateParams.timeZoneId;
    vm.newRepliedQueriesCount = 0;
    vm.serviceType = $stateParams.serviceType;

    vm.activeTab = _.toInteger($stateParams.tab) || 0;

    init();

    function init() {
      getClaim();
    }
    function getClaim() {
      vm.loading += 1;
      inpatientClaimSvc
        .getInpatientClaimDetailAsync({ id: vm.claimNumber })
        .success((data) => {
          vm.claim = {
            claimNo: data.claimNumber,
            type: data.latestRequestType,
            status: data.claimStatusId,
            guaranteeLetterNumber: data.guaranteeLetterNumber,
            patientRefNo: data.hospitalBillReferenceNumber,
            finalBillAmount: data.totalBillAmount,
            finalguaranteedAmount: data.currentGuaranteeAmount,
            exceededAmount: data.exceededAmount,
            submissionTime: App.getFullDateTimeString(data.claimDate, vm.timeZoneId),
            lastUpdated: App.getFullDateTimeString(data.lastModificationTime, vm.timeZoneId),
            guaranteeLetterUrl: data.guaranteeLetterUrl,
            documents: data.attachments,
            guaranteeLetterStatus: data.guaranteeLetterStatus,
            patientNonGlUrl: data.patientNonGlUrl,
            hospitalNonGlUrl: data.hospitalNonGlUrl,
            isEscalated: data.isEscalated,
            timeZoneId: vm.timeZoneId,
            serviceRequestId: data.serviceRequestId,
            canPickUpRequest: data.canPickUpRequest,
            isAssignee: data.isAssignee,
          };

          vm.patient = {
            name: data.patientName,
            nationalId: data.nationalId,
            gender: data.gender,
            dob: data.dateOfBirth ? App.getDateString(moment.utc(data.dateOfBirth)) : null,
            joinDate: data.joinDate ? App.getDateString(moment.utc(data.joinDate)) : null,
            scheduledDeactivationDate: data.deactivationDate
              ? App.getDateString(moment.utc(data.deactivationDate))
              : null,

            patientActivationStatus: data.patientActivationStatus,
            patientDeletionStatus: data.patientDeletionStatus,
            patientTerminationStatus: data.patientTerminationStatus,
            specialNotes: data.specialNotes,
          };

          vm.currencyCode = data.currencyCode;
          vm.letterNumber = data.guaranteeLetterNumber;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }
  }
})();
